export default __webpack_public_path__ + "static/media/story_img_case2.4ee03002.jpg";